// @flow

import React from 'react';
import { compose } from 'redux';
import withCarBlockProps from './withCarBlockProps';
import PromotionCarBlock from './promotionCarBlock';
import type { StateProps } from './types';
import withPdbIdMapping from '../withPdbIdMapping';
import withGTMImpression from './withGTMImpression';

type Props = {|
  flapover_text: string,
  query_data?: ?Object,
  pdb_id?: string, // withPdbIdMapping input
  pdbId?: string, // withPdbIdMapping output
  nr?: string,
  title?: string,
  subtitle?: string,
  background?: string,
  processGtmEvent: Function,
|} & StateProps;

const ACFCarBlock = ({
  flapover_text,
  paymentText,
  deliveryText,
  remarkText,
  roadTaxNote,
  buttonText,
  configLink,
  modelInfoLink,
  isReserved,
  make,
  model,
  engine,
  power,
  productType,
  fueltype,
  defaultImage,
  price,
  deliveryTime,
  mileageName,
  noBox,
  isAvailable,
  notAvailableText,
  nr,
  title,
  subtitle,
  background,
  processGtmEvent,
  ...rest
}: Props) => (
  <PromotionCarBlock
    nr={nr}
    title={title}
    subtitle={subtitle}
    background={background}
    discountText={flapover_text}
    hasRemarks
    paymentText={paymentText}
    remarkText={remarkText}
    deliveryText={deliveryText}
    roadTaxNote={roadTaxNote}
    buttonText={buttonText}
    configLink={configLink}
    modelInfoLink={modelInfoLink}
    isReserved={isReserved}
    make={make}
    model={model}
    engine={engine}
    power={power}
    productType={productType}
    fueltype={fueltype}
    defaultImage={defaultImage}
    price={price}
    deliveryTime={deliveryTime}
    mileageName={mileageName}
    noBox={noBox}
    isAvailable={isAvailable}
    notAvailableText={notAvailableText}
    {...rest}
  />
);

ACFCarBlock.defaultProps = {
  query_data: null,
  pdb_id: '', // withPdbIdMapping input
  pdbId: '', // withPdbIdMapping output
  nr: '',
  title: '',
  subtitle: '',
  background: '',
};

export default compose(
  withPdbIdMapping,
  withCarBlockProps,
  withGTMImpression,
)(ACFCarBlock);
